
export default () => {
    // Handle triggers
    document.querySelectorAll(".js-modal-trigger").forEach(trigger => {
        trigger.addEventListener("click", event => {
            event.preventDefault();

            const modal = document.getElementById(trigger.getAttribute('aria-controls'));

            if (!modal) {
                return;
            }

            openModal(modal);
        });
    });

    // Handle close buttons
    document.querySelectorAll(".js-modal-close").forEach(closeBtn => {
        closeBtn.addEventListener("click", event => {
            event.preventDefault();

            const modal = closeBtn.closest(".js-modal");

            if (!modal) {
                return;
            }

            closeModal(modal);
        });
    });

    // Close modals when clicking outside
    document.querySelectorAll(".js-modal").forEach(modal => {
        modal.addEventListener("click", event => {
            event.preventDefault();

            if (event.target === modal) {
                closeModal(modal);
            }
        });
    });

    // Close all modals with the ESC key
    document.addEventListener('keydown', e => {
        if (e.key === 'Escape') {
            document.querySelectorAll('.js-modal[aria-hidden="false"]').forEach(modal => {
                closeModal(modal);
            });
        }
    });

    function openModal(modal) {
        modal.classList.add("is-open");
        modal.setAttribute("aria-hidden", "false");
        modal.removeAttribute("inert");
    }

    function closeModal(modal) {
        // Remove focus from modal
        if (modal.contains(document.activeElement)) {
            modal.blur();
        }

        // Close modal
        modal.classList.remove("is-open");
        modal.setAttribute("inert", "");
        modal.setAttribute("aria-hidden", "true");

        // Focus back to trigger
        document.querySelector(`[aria-controls="${modal.id}"]`)?.focus()
    }
};
